import { createTheme } from "@aws-amplify/ui-react";
import theme from "./theme";

const amplifyTheme = createTheme({
  name: "AuthTheme",
  tokens: {
    colors: {
      font: {
        primary: theme.palette.primary.main,
      },
    },
    components: {
      tabs: {
        item: {
          _active: {
            color: theme.palette.primary.main,
            borderColor: theme.palette.primary.main,
          },
          _hover: {
            color: theme.palette.primary.dark,
          },
          color: theme.palette.text.secondary,
        },
      },
      button: {
        primary: {
          backgroundColor: theme.palette.primary.main,
        },
        link: {
          color: theme.palette.error.main,
          _hover: {
            backgroundColor: theme.palette.background.default,
            color: "#000",
          },
        },
      },
    },
  },
});

export default amplifyTheme;
